// src/hooks/useWebSocket.js
import { useEffect } from "react";
import { useWebSocketContext } from "../context/WebSocketContext";

/* Websocket Incoming message handlers */
const useWSInHandler = (eventType, handler) => {
  const { registerHandler, unregisterHandler } = useWebSocketContext();

  useEffect(() => {
    registerHandler(eventType, handler);

    return () => {
      unregisterHandler(eventType, handler);
    };
  }, [eventType, handler, registerHandler, unregisterHandler]);
};

/* Topic handlers */
const useWSInTopicCreated = (createTopic) => {
  useWSInHandler("topic_created", (message) => {
    createTopic({ ...message });
  });
};

const useWSInTopicUpdated = (appendMessage) => {
  useWSInHandler("topic_updated", (messageData) => {
    appendMessage(messageData.message.topic_id, messageData.message);
  });
};

const useWSInTopicDeleted = (deleteTopicById) => {
  useWSInHandler("topic_deleted", (message) => {
    deleteTopicById(message.topic_id);
  });
};

/* Card handlers */

const useWSInCardCreated = (createCard) => {
  useWSInHandler("card_created", (message) => {
    createCard(message.card);
  });
};

const useWSInCardDisplayTypeUpdated = (recvUpdateCardDisplayType) => {
  useWSInHandler("card_display_updated", (message) => {
    recvUpdateCardDisplayType(message);
  });
};

const useWSInCardStatus = (updateCardStatus) => {
  useWSInHandler("card_status", (message) => {
    updateCardStatus(message);
  });
};

const useWSInCardDeleted = (cardDeleted) => {
  useWSInHandler("card_deleted", (message) => {
    cardDeleted(message.card_id);
  });
};

/* Dashboard handlers */
const useWSInLayoutsUpdated = (setLayouts) => {
  useWSInHandler("layouts_updated", (message) => {
    setLayouts(message.layouts);
  });
};

/* Websocket Outgoing message handlers */
const useWSOutHandler = (messageType) => {
  const { sendMessage } = useWebSocketContext();

  return (payload) => {
    sendMessage({
      type: messageType,
      ...payload,
      timestamp: Date.now(),
    });
  };
};

const useWSOutLayoutsUpdated = (token) => {
  const send = useWSOutHandler("layouts_updated");

  return (layouts) => {
    send({ token, layouts });
  };
};

const useWSOutExecuteRequest = (token) => {
  const send = useWSOutHandler("execute_request");

  return (card) => {
    send({ token, card_id: card.id });
  };
};

export {
  useWSInTopicCreated,
  useWSInTopicUpdated,
  useWSInTopicDeleted,
  useWSInCardCreated,
  useWSInCardDisplayTypeUpdated,
  useWSInCardDeleted,
  useWSInCardStatus,
  useWSInLayoutsUpdated,
  useWSOutExecuteRequest,
  useWSOutLayoutsUpdated,
};
